import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface BulkRetryConfirmationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedCount: number;
  handleBulkRetry: () => void;
}

export const BulkRetryConfirmationDialog: React.FC<
  BulkRetryConfirmationDialogProps
> = ({ open, onOpenChange, selectedCount, handleBulkRetry }) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Vorgänge erneut verarbeiten?</AlertDialogTitle>
          <AlertDialogDescription>
            {selectedCount === 1
              ? 'Möchten Sie diesen Vorgang erneut verarbeiten?'
              : `Möchten Sie diese ${selectedCount} Vorgänge erneut verarbeiten?`}{' '}
            Bei Archivierungsfehlern gleicht OPM unbestätigte Uploads und
            Kommunikationsanlagen automatisch mit Powercloud ab. Bestätigte
            Dokumente bleiben erhalten. Bei E-Mails folgt anschließend der
            bislang ausstehende Kundenversand. Ein bereits begonnener Versand
            verhindert den Archivierungsneustart.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Abbrechen</AlertDialogCancel>
          <AlertDialogAction onClick={handleBulkRetry}>
            Erneut verarbeiten
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
